import {Component, OnInit, ViewChild} from '@angular/core';
import {FabThemeService} from '@fabric/components/theme';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {FabMessageService} from '@fabric/components/message';
import {ManagerService} from './manager.service';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {AuthenticationService} from '../core/authentication/authentication.service';
import {WorkAbroad} from '../admin/models/workAbroad.model';
import {ExcelUtil} from '../common/web-workers/excel-export.worker';
import {writeFile} from 'xlsx';
import {ManagerFilter} from './managerFilter';
import {MatSort} from '@angular/material/sort';
import {Vacation} from '../admin/models/vacation.model';
import {AllRequestPopUpComponent} from './allrequest-pop-up/all-request-pop-up.component';
import {AbsenceCalendarPopUpComponent} from '../absence-calendar-pop-up/absence-calendar-pop-up.component';
import {Employee} from '../admin/models/employee.model';
import {Team} from '../admin/models/team.model';
import {EditTeamPopUpComponent} from '../hr/edit-team-pop-up/edit-team-pop-up.component';
import {map, Observable, shareReplay} from 'rxjs';
import {HttpErrorResponse} from '@angular/common/http';
import {DeclinePopUpComponent} from '../decline-pop-up/decline-pop-up.component';
import {DatePipe} from "@angular/common";
import {
    RequestCancelDecisionPopUpComponent
} from "./request-cancel-decision-pop-up/request-cancel-decision-pop-up.component";

@Component({
    selector: 'app-manager',
    templateUrl: './manager.component.html',
    styleUrls: ['./manager.component.scss']
})
export class ManagerComponent implements OnInit {
    public dataSourceWork: MatTableDataSource<any> = new MatTableDataSource<any>([]);
    public dataSourceSwitchVacation: MatTableDataSource<any> = new MatTableDataSource<any>([]);
    public dataSourceVacation: MatTableDataSource<any> = new MatTableDataSource<any>([]);
    public dataSourceSwitchWorkManager: MatTableDataSource<any> = new MatTableDataSource<any>([]);
    public dataSourceTeam: MatTableDataSource<Team> = new MatTableDataSource<Team>([]);
    public teamFieldNames = ['teamName', 'manager', 'alternateManager', 'edit'];
    public displayTeamFieldNames = ['Name', 'Manager', 'Alternative Manager', 'Edit Team'];
    public managerNames: string[] = [];
    public altManagerNames: string[] = [];
    public backupVacationSwitchData: any[] = [];
    public backupWorkAbroadSwitchData: any[] = [];
    public backupVacationData: any[] = [];
    public backupVacationDataCancel: any[] = [];
    public backupWorkAbroadDataCancel: any[] = [];
    public backupWorkAbroadData: any[] = [];
    public countrySettingsCode: any;
    public dataSourceCancelVacationRequests: MatTableDataSource<any> = new MatTableDataSource<any>([]);
    public dataSourceCancelWorkRequests: MatTableDataSource<any> = new MatTableDataSource<any>([]);

    public fieldNamesVacation = ['firstName', 'lastName', 'dateCreated', 'halfDay', 'startDate', 'endDate',
        'numberOfAnnualLeaveDays', 'requestStatus', 'absenceType', 'absenceReason', 'approve', 'decline'];
    public displayNamesVacation = ['First Name', 'Last Name', 'Date Created', 'Half day', 'Start Date', 'End Date',
        'Total Absence', 'Request Status', 'Absence Type', 'Absence Reason', 'Approve', 'Decline'];

    public fieldNamesVacationCancel = ['firstName', 'lastName', 'dateCreated', 'halfDay', 'startDate', 'endDate',
        'numberOfAnnualLeaveDays', 'requestStatus', 'absenceType', 'absenceReason', 'approve/decline'];
    public displayNamesVacationCancel = ['First Name', 'Last Name', 'Date Created', 'Half day', 'Start Date', 'End Date',
        'Total Absence', 'Request Status', 'Absence Type', 'Absence Reason', 'Approve/Decline'];

    public fieldNamesVacationAllRequest = ['firstName', 'lastName', 'contractType', 'holidayTaken', 'vacationAllowanceRemaining', 'vacationAllowanceCarryover'];
    public displayNamesVacationAllRequest = ['First Name', 'Last Name', 'Employee Type', 'Holidays Taken', 'Holidays Left',
        'Carry Over For this Year'];

    public fieldNamesWork = ['firstName', 'lastName', 'country', 'dateCreated', 'startDate', 'endDate',
        'numberOfAnnualLeaveDays', 'numberOfWorkAbroadDays', 'requestStatus', 'approve', 'decline'];
    public displayNamesWork = ['First Name', 'Last Name', 'Country', 'Date Created', 'Start Date', 'End Date',
        'Annual Leave Length', 'Work Abroad Length', 'Approval Status', 'Approve', 'Decline'];

    public fieldNamesWorkCancel = ['firstName', 'lastName', 'country', 'dateCreated', 'startDate', 'endDate',
        'numberOfAnnualLeaveDays', 'numberOfWorkAbroadDays', 'requestStatus', 'approve/decline'];
    public displayNamesWorkCancel = ['First Name', 'Last Name', 'Country', 'Date Created', 'Start Date', 'End Date',
        'Annual Leave Length', 'Work Abroad Length', 'Approval Status', 'Approve/Decline'];

    public fieldNamesWorkAllRequest = ['firstName', 'lastName', 'contractType', 'workTaken', 'allowanceRemaining'];
    public displayNamesWorkAllRequest = ['First Name', 'Last Name', 'Employee Type', 'Work Abroad Days Taken', 'Work Abroad Days Remaining'];

    public vacationData: any[] = [];
    public workAbroadData: any[] = [];
    public vacationSwitch: any[] = [];
    public workAbroadSwitch: any[] = [];
    public cancelVacationData: any[] = [];
    public cancelWorkData: any[] = [];
    public employeeList: Employee[] = [];
    public filterEntity: ManagerFilter;
    public refreshLoading = false;
    public stringIOFormat = true;
    public isClosed = true;
    public teamData = {} as any;
    public rawData: any[] = [];
    public allData: any[] = [];
    public searchValue: string = '';
    public isChecked = false;
    public isLoading = false;
    public isExcelExporting = false;
    public getTeamID = new Map<string, string>();
    public getTeamName = new Map<string, string>();
    public gminValue: string = '';
    public listOfTeamName: string[] = [];
    public year: string[] = [];
    public getDisplayValue = new Map<string, string>();
    public getDisplayValueWork = new Map<string, string>();
    public currentYear: string = '';
    public nameArray: any[] = [];
    public isManager = true;
    public isApproveAllPressed = false;
    public searchTxt: any;
    public isDisabled: boolean = false;

    @ViewChild('vacationPaginator', {static: false})
    set vacationPaginator(value: MatPaginator) {
        if (this.dataSourceVacation) {
            this.dataSourceVacation.paginator = value;
        }
    };

    @ViewChild('switchVacationPaginator', {static: false})
    set switchVacationPaginator(value: MatPaginator) {
        if (this.dataSourceSwitchVacation) {
            this.dataSourceSwitchVacation.paginator = value;
        }
    };

    @ViewChild('workAbroadPaginator', {static: false})
    set workAbroadPaginator(value: MatPaginator) {
        if (this.dataSourceWork) {
            this.dataSourceWork.paginator = value;
        }
    };

    @ViewChild('switchWorkAbroadPaginator', {static: false})
    set switchWorkAbroadPaginator(value: MatPaginator) {
        if (this.dataSourceSwitchWorkManager) {
            this.dataSourceSwitchWorkManager.paginator = value;
        }
    };

    @ViewChild('teamsPaginator', {static: false})
    set teamsPaginator(value: MatPaginator) {
        if (this.dataSourceTeam) {
            this.dataSourceTeam.paginator = value;
        }
    };

    @ViewChild('vacationCancelPaginator', {static: false})
    set cancelRequestPaginator(value: MatPaginator) {
        if (this.dataSourceCancelVacationRequests) {
            this.dataSourceCancelVacationRequests.paginator = value;
        }
    };

    @ViewChild('workAbroadCancelPaginator', {static: false})
    set workAbroadCancelRequestPaginator(value: MatPaginator) {
        if (this.dataSourceCancelWorkRequests) {
            this.dataSourceCancelWorkRequests.paginator = value;
        }
    };

    @ViewChild(MatSort, {static: false})
    set sort(value: MatSort) {
        if (this.dataSourceVacation && this.dataSourceSwitchVacation && this.dataSourceWork && this.dataSourceSwitchWorkManager && this.dataSourceCancelVacationRequests && this.dataSourceCancelWorkRequests) {
            this.dataSourceVacation.sort = value;
            this.dataSourceSwitchVacation.sort = value;
            this.dataSourceWork.sort = value;
            this.dataSourceSwitchWorkManager.sort = value;
            this.dataSourceCancelVacationRequests.sort = value;
            this.dataSourceCancelWorkRequests.sort = value;
        }
    };

    @ViewChild('teamTable', {read: MatSort, static: false})
    set sortTeamTable(value: MatSort) {
        if (this.dataSourceTeam) {
            this.dataSourceTeam.sort = value;
        }
    };

    constructor(public readonly themeService: FabThemeService,
                private managerService: ManagerService,
                private fabMessageService: FabMessageService,
                public dialog: MatDialog,
                private authService: AuthenticationService) {
        this.filterEntity = new ManagerFilter();
    }
    ngOnInit(): void {
        this.countrySettingsCode = localStorage.getItem('CountryCode');
        this.currentYear = String(new Date().getFullYear());
        this.filterEntity.year = this.currentYear;
        this.gminValue = this.authService.userInfo.gmin || '';
        this.managerService.fetchTeamIdByGmin(this.gminValue).subscribe({
            next: (data) => {
                if (data.length > 0) {
                    this.teamData = data;
                    this.getTeamDetails(data);
                    this.dataSourceTeam.data = data;
                    this.dataSourceTeam.sort = this.sortTeamTable;
                    this.getListOfTeamId();
                    this.initializeValue();
                    for (const i of this.listOfTeamName) {
                        this.getTableData(i);
                    }
                } else {
                    this.isLoading = false;
                    this.isManager = false;
                    this.fabMessageService.displayErrorMessage('No associated Teams')
                }
            }, error: () => {
                this.isLoading = false;
                this.isManager = false;
                this.fabMessageService.displayErrorMessage('Error fetching data')
            }, complete: () => {
                this.isManager = true;
                setTimeout(() => {
                    this.isLoading = true;
                }, 3000);
            }
        });
        this.isLoading = false;
    }

    sortVacationStartDate() {
        for (const element of this.dataSourceVacation.data) {
            if (element.startDate.includes('/')) {
                const startDate = element.startDate;
                const endDate = element.endDate;
                const [day, month, year] = startDate.split('/');
                const [dayEnd, monthEnd, yearEnd] = endDate.split('/');
                element.startDate = new Date(+year, +month - 1, +day).toISOString();
                element.endDate = new Date(+yearEnd, +monthEnd - 1, +dayEnd).toISOString();
            }
        }
    }

    sortWorkAbroadStartDate() {
        for (const element of this.dataSourceWork.data) {
            if (element.startDate.includes('/')) {
                const startDate = element.startDate;
                const endDate = element.endDate;
                const [day, month, year] = startDate.split('/');
                const [dayEnd, monthEnd, yearEnd] = endDate.split('/');
                element.startDate = new Date(+year, +month - 1, +day).toISOString();
                element.endDate = new Date(+yearEnd, +monthEnd - 1, +dayEnd).toISOString();
            }
        }
    }

    /**
     * Opens a popup to edit a team
     */
    public openEditTeamPopup(data: Team): void {
        this.dialog.open(EditTeamPopUpComponent, {data: data}).afterClosed().subscribe(() => {
            this.refreshTeam();
        });
    }

    /**
     *Helps to retrieve the manager name from the obtained GMIN
     *@param value The Team data to be processed.
     * */
    public getTeamDetails(value: Team[]) {
        for (let i = 0; i < value.length; i++) {
            this.getEmployeeDisplayName(value[i].manager).subscribe({
                next: (managerName) => {
                    this.managerNames[i] = managerName;
                },
            });
            this.getEmployeeDisplayName(value[i].alternateManager).subscribe({
                next: (altManagerName) => {
                    this.altManagerNames[i] = altManagerName;
                },
            });
        }
    }

    /**
     * Show employee name instead of gmin.
     * @param manager
     */
    public getEmployeeDisplayName(manager: string): Observable<any> {

        return this.managerService.searchForEmployees(manager).pipe(map(response => {
            if (response && response.body && response.body.length > 0) {
                const employee = response.body[0];
                employee.displayName = employee.firstName + ' ' + employee.lastName;

                shareReplay(1);
                return employee.displayName;
            } else {
                this.fabMessageService.displayErrorMessage('Employee Not Found');
            }
        }));
    }

    /**
     * Gets a list of team ids
     */
    public getListOfTeamId() {
        this.teamData.forEach((value: any) => {
            this.listOfTeamName.push(value.teamName);
            this.getTeamID.set(value.teamName, value.id);
            this.getTeamName.set(value.id, value.teamName);
        });
        this.listOfTeamName = this.managerService.getUniqueValues(this.listOfTeamName);
    }

    /**
     * Gets year for filter
     */
    public getYearForFilter() {
        this.rawData.forEach((value: any) => {
            value.vacation.forEach((ta: any) => {
                this.year.push(this.managerService.getYear(ta.endDate));
            });
            value.workAbroad.forEach((val: any) => {
                this.year.push(this.managerService.getYear(val.endDate));
            });
        });
        this.year = this.managerService.getUniqueValues(this.year).sort();
    }

    /**
     * Returns the table data by calling a service method with the team Id
     * @param teamName is used to determine teamId for the service call
     */
    public getTableData(teamName: string) {
        this.managerService.fetchAllEmployeeDetailsByTeamId(this.getTeamID.get(teamName)).subscribe({
            next: (value) => {
                if (value.length > 0) {
                    this.employeeList.push(...value);
                    this.rawData.push(...value);
                    this.getYearForFilter();
                    const personalAndWorkAbroadValues = this.managerService.getData(value, this.getTeamName);
                    this.assignTableData(personalAndWorkAbroadValues);
                    this.assignCancelRequestTableData(personalAndWorkAbroadValues);
                    this.allData.push(personalAndWorkAbroadValues);
                    this.calculateDisplayValue('', []);
                    this.refreshLoading = false;
                    this.filterTableDataSources();
                } else {
                    this.refreshLoading = false;
                }
            }, error: () => this.fabMessageService.displayErrorMessage('error in fetching team ID')
        });
    }

    public assignTableData(data: any) {
        const vacation: any[] = [];
        const work: any[] = [];
        data.pendingVacation.forEach((val: any) => {
            if (val.requestStatus == 'PENDING') {
                vacation.push(val);
            }
        });
        data.pendingWork.forEach((value: any) => {
            if (value.requestStatus == 'PENDING') {
                work.push(value);
            }
        });
        this.vacationData.push(...vacation);
        this.workAbroadData.push(...work);
        this.vacationSwitch.push(...data.allVacationRequest);
        this.workAbroadSwitch.push(...data.allWorkRequest);
        this.assignToTableValues();
        this.backupVacationSwitchData = this.dataSourceSwitchVacation.data;
        this.backupWorkAbroadSwitchData = this.dataSourceSwitchWorkManager.data;
        this.backupVacationData = this.dataSourceVacation.data;
        this.backupWorkAbroadData = this.dataSourceWork.data;
        this.getEmployeeNameArray();
        this.sortVacationStartDate();
        this.sortWorkAbroadStartDate();
    }

    public assignCancelRequestTableData(data: any) {
        const vacation: any[] = [];
        const work: any[] = [];
        data.approvedVacation.forEach((val: any) => {
            if (val.requestStatus == 'CANCEL_REQUEST') {
                vacation.push(val);
            }
        });
        data.pendingWork.forEach((value: any) => {
            if (value.requestStatus == 'CANCEL_REQUEST') {
                work.push(value);
            }
        });
        this.cancelVacationData.push(...vacation);
        this.cancelWorkData.push(...work);
        this.assignToTableValues();
        this.backupVacationDataCancel = this.dataSourceCancelVacationRequests.data;
        this.backupWorkAbroadDataCancel = this.dataSourceCancelWorkRequests.data;
        this.getEmployeeNameArray();
        this.sortVacationStartDate();
        this.sortWorkAbroadStartDate();
    }

    public assignToTableValues() {
        this.dataSourceVacation.data = this.vacationData;
        this.dataSourceWork.data = this.workAbroadData;
        this.dataSourceSwitchVacation.data = this.vacationSwitch;
        this.dataSourceSwitchWorkManager.data = this.workAbroadSwitch;
        this.dataSourceCancelVacationRequests.data = this.cancelVacationData;
        this.dataSourceCancelWorkRequests.data = this.cancelWorkData;
    }


    public sortDate(date: string) {
        let returnValue = '';
        if (date.charAt(2) === '/') {
            returnValue = date;
        } else {
            const newDateString = new DatePipe('en-US').transform(date, 'dd/MM/yyyy');
            returnValue = newDateString ? newDateString : '';
        }
        return returnValue;
    }

    /**
     * Calls a service method to get a string representing a boolean value
     * @param bool The boolean value to check
     */
    public halfDayStatus(bool: boolean): string {
        return this.managerService.halfDayStatus(bool);
    }

    /**
     * This method opens the popup and populates it with data
     * @param data The vacation/work abroad request to open
     * @param tabName Name of the tab
     * @param year Year
     */
    public openAllRequestPopup(data: any, tabName: string, year: string): void {
        if (this.isChecked) {
            let multiplyValue = 0.9;
            const dialogConfig = new MatDialogConfig();
            if (window.innerHeight > 700) {
                multiplyValue = 0.7;
                dialogConfig.maxHeight = window.innerHeight * multiplyValue;
                dialogConfig.minHeight = window.innerHeight * multiplyValue;
                dialogConfig.minWidth = window.innerWidth * 0.05;

            } else {
                dialogConfig.maxHeight = window.innerHeight * multiplyValue;
                dialogConfig.minHeight = window.innerHeight * multiplyValue;
                dialogConfig.minWidth = window.innerWidth * 0.05;
            }
            dialogConfig.data = [
                this.allData,
                data,
                tabName
            ];
            this.dialog.open(AllRequestPopUpComponent, dialogConfig);
        }
    }

    /**
     * Opens the AbsenceCalendarPopup, passing in the employeeList
     */
    public openAbsenceCalendarPopup(): void {
        this.dialog.open(AbsenceCalendarPopUpComponent, {data: [this.employeeList, 'manager']});
    }

    /**
     * This method takes a vacation object,
     * changes the request status to approved,
     * updates the updatedBy field,
     * and then calls the approve vacation request method in the service which makes the api call
     * @param data the vacation to be processed
     */
    public approveVacation(data: Vacation) {
        this.isDisabled = true;
        if (!this.isApproveAllPressed) {
            this.refreshLoading = true;
            this.stringIOFormat = false;
        }
        if(data.absenceReason && data.absenceReason.includes("Work Abroad"))
        {
            data.startDate = this.formatDate(data.startDate);
            data.endDate = this.formatDate(data.endDate);
            this.fabMessageService.displayErrorMessage('Error! Please approve Work Abroad request first!');
            this.refreshPersonalAndWorkAbroadTable();
            this.stringIOFormat = true;
            const [day, month, year] = data.startDate.split('/');
            data.startDate = new Date(+year, +month - 1, +day).toISOString();
            const [dayEnd, monthEnd, yearEnd] = data.endDate.split('/');
            data.endDate = new Date(+yearEnd, +monthEnd - 1, +dayEnd).toISOString();
        }
        else {
            data.requestStatus = 'APPROVED';
            data.updatedBy = this.gminValue;
            data.startDate = this.formatDate(data.startDate);
            data.endDate = this.formatDate(data.endDate);
            this.fabMessageService.displayMessage('Approval request in progress. Please wait...');
            this.managerService.approveVacationRequest(data).subscribe({
                next: () => {
                    if (!this.isApproveAllPressed && this.refreshLoading) {
                        this.refreshPersonalAndWorkAbroadTable();
                    }
                    this.stringIOFormat = true;
                    this.fabMessageService.displayMessage('Success! Approval request granted.');
                    const [day, month, year] = data.startDate.split('/');
                    data.startDate = new Date(+year, +month - 1, +day).toISOString();
                    const [dayEnd, monthEnd, yearEnd] = data.endDate.split('/');
                    data.endDate = new Date(+yearEnd, +monthEnd - 1, +dayEnd).toISOString();
                }, error: (err: HttpErrorResponse) => {
                    data.requestStatus = 'PENDING';
                    this.fabMessageService.displayErrorMessage(err.error.errorMessage);
                }
            });
        }
        this.isDisabled = false;

    }

    /**
     * This method takes a string of a vacation id and declines the request
     * @param vacationValue The string is the vacation id
     */
    public openDeclineVacationPopUp(vacationValue: Vacation) {
        this.refreshLoading = true;
        this.stringIOFormat = false;
        this.isClosed = false;
        vacationValue.updatedBy = this.gminValue;
        vacationValue.startDate = this.formatDate(vacationValue.startDate);
        vacationValue.endDate = this.formatDate(vacationValue.endDate);
        this.dialog.open(DeclinePopUpComponent,
            {data: {value: vacationValue, tag: 'personal'}}).afterClosed().subscribe(() => {
            this.stringIOFormat = true;
            this.isClosed = true;
            this.refreshPersonalAndWorkAbroadTable();
            const [day, month, year] = vacationValue.startDate.split('/');
            vacationValue.startDate = new Date(+year, +month - 1, +day).toISOString();
            const [dayEnd, monthEnd, yearEnd] = vacationValue.endDate.split('/');
            vacationValue.endDate = new Date(+yearEnd, +monthEnd - 1, +dayEnd).toISOString();
        });
    }

    /**
     * This method takes a string of a vacation id and declines the request
     * @param data The string is the vacation id
     */
    public declineVacation(data: Vacation) {
        this.refreshLoading = true;
        data.requestStatus = 'DECLINED';
        data.updatedBy = this.gminValue;
        this.managerService.declineVacationRequest(data).subscribe({
            next: () => {
                this.fabMessageService.displayMessage('success');
            }, error: (err: HttpErrorResponse) => {
                this.fabMessageService.displayErrorMessage(err.error.errorMessage);
            }
        });
        this.stringIOFormat = true;
        this.refreshPersonalAndWorkAbroadTable();
        const [day, month, year] = data.startDate.split('/');
        data.startDate = new Date(+year, +month - 1, +day).toISOString();
        const [dayEnd, monthEnd, yearEnd] = data.endDate.split('/');
        data.endDate = new Date(+yearEnd, +monthEnd - 1, +dayEnd).toISOString();
    }

    /**
     * This method takes a workAbroad object,
     * changes the request status to approved,
     * updates the updatedBy field,
     * and then does the same for any vacations taken within this workAbroad request.
     * Then it calls the approve work request method in the service which makes the api call
     * @param data WorkAbroad object
     */
    public approveWork(data: WorkAbroad) {
        if (!this.isApproveAllPressed) {
            this.refreshLoading = true;
            this.stringIOFormat = false;
        }
        data.requestStatus = 'APPROVED';
        this.isClosed = false;
        data.updatedBy = this.gminValue;
        data.startDate = this.formatDate(data.startDate);
        data.endDate = this.formatDate(data.endDate);
        if (data.vacations.length > 0) {
            data.vacations.forEach((dat: any) => {
                dat.requestStatus = 'APPROVED';
                dat.updatedBy = this.gminValue;
            });
        }
        this.refreshLoading = true;
        this.managerService.approveWorkRequest(data).subscribe({
            next: () => {
                if (!this.isApproveAllPressed && this.refreshLoading) {
                    this.refreshPersonalAndWorkAbroadTable();
                }
                this.stringIOFormat = true;
                this.sortWorkAbroadStartDate();
                this.fabMessageService.displayMessage('success');
            }, error: (err: HttpErrorResponse) => {
                data.requestStatus = 'PENDING';
                this.refreshLoading = false;
                this.refreshPersonalAndWorkAbroadTable();
                this.fabMessageService.displayErrorMessage(err.error.errorMessage);
            }
        });
    }

    /**
     * This method takes a string of a workAbroad id and
     * declines the request
     * @param data the data is the workabroad data
     */
    public declineWorkAbroad(data: any) {
        this.stringIOFormat = false;
        this.isClosed = false;
        data.startDate = this.formatDate(data.startDate);
        data.endDate = this.formatDate(data.endDate);
        this.dialog.open(DeclinePopUpComponent,
            {data: {value: data, tag: 'workabroad'}}).afterClosed().subscribe(() => {
            this.stringIOFormat = true;
            this.isClosed = true;
            this.refreshPersonalAndWorkAbroadTable();
            this.sortWorkAbroadStartDate();
        });
    }

    /**
     * Exports an excel of the table data
     */
    public exportExcel(tabName: string): void {
        let data: any[];
        let fileName: string = '';
        if (tabName == 'workAbroad') {
            data = this.dataSourceWork.data;
            fileName = 'WorkAbroad'
        } else {
            data = this.dataSourceVacation.data;
            fileName = 'vacation'
        }
        if (data.length > 0) {
            this.isExcelExporting = true;
            ExcelUtil.exportObjectArrayMultiThreaded(data, fileName)
                .subscribe({
                    next: (workbook) => {
                        if (workbook) {
                            writeFile(workbook, fileName + '.xlsx');
                            this.isExcelExporting = false;
                        }
                    },
                    error: (err: HttpErrorResponse) => {
                        this.fabMessageService.displayErrorMessage(err.error.errorMessage);
                        this.isExcelExporting = false;
                    }
                });
        } else {
            this.fabMessageService.displayErrorMessage('No data to export');
        }
    }

    /**
     * Calculate the values of the vacation cards and displays those values
     */
    public calculateDisplayValue(year: string, team: string[]) {
        this.dataSourceSwitchWorkManager.data = this.workAbroadSwitch;
        const value = this.managerService.calculateDisplayValueOfVacation(this.dataSourceSwitchVacation.data, year, team);
        const pendingDays = this.managerService.calculatePendingDaysOfVacation(this.dataSourceVacation.data, year, team);
        this.getDisplayValue.set('leaveEntitlement', String(value.annualLeave));
        this.getDisplayValue.set('remainingDays', String(value.remainingDays));
        this.getDisplayValue.set('pendingRequests', String(pendingDays.pendingRequests));
        this.getDisplayValue.set('daysUsed', String(value.daysUsed));
        this.getDisplayValue.set('pendingDays', String(pendingDays.pendingDays));
        this.calculateDisplayWorkValue(year, team);
    }

    /**
     * Calculate the values of the work abroad cards and displays those values
     */
    public calculateDisplayWorkValue(year: string, team: string[]) {
        const value = this.managerService.calculateDisplayOfWork(this.workAbroadSwitch, year, team);
        const pendingWorkDays = this.managerService.calculatePendingDaysOfWork(this.dataSourceWork.data, year, team);
        this.getDisplayValueWork.set('leaveEntitlement', String(value.annualWork));
        this.getDisplayValueWork.set('remainingDays', String(value.remainingWorkDays));
        this.getDisplayValueWork.set('pendingRequests', String(pendingWorkDays.pendingRequests));
        this.getDisplayValueWork.set('daysUsed', String(value.workDaysUsed));
        this.getDisplayValueWork.set('pendingDays', String(pendingWorkDays.pendingWorkDays));
    }

    public clearDropdown(field: string) {
        this.filterEntity[field] = new ManagerFilter()[field];
        this.calculateDisplayValue(this.filterEntity.year, this.filterEntity.teamName);
    }

    /**
     * Calls a manager service method to get an array of full names and gmin values from the vacation switch datasource
     */
    public getEmployeeNameArray(): void {
        this.nameArray = this.managerService.getEmployeeNameArray(this.dataSourceSwitchVacation.data);
        this.calculateDisplayValue(this.filterEntity.year, this.filterEntity.teamName);
    }

    /**
     * Filters the datasources to only include entries which contain the event string in the first and last name or gmin.
     */
    public filterTableDataSources(): void {
        this.dataSourceSwitchVacation.data = this.backupVacationSwitchData;
        this.dataSourceSwitchWorkManager.data = this.backupWorkAbroadSwitchData;
        this.dataSourceVacation.data = this.backupVacationData;
        this.dataSourceWork.data = this.backupWorkAbroadData;
        this.dataSourceCancelVacationRequests.data = this.backupVacationDataCancel;
        this.dataSourceCancelWorkRequests.data = this.backupWorkAbroadDataCancel;
        this.dataSourceSwitchVacation.data = this.managerService.filterDataSource(this.searchValue, this.nameArray, this.dataSourceSwitchVacation.data);
        this.dataSourceSwitchWorkManager.data = this.managerService.filterDataSource(this.searchValue, this.nameArray, this.dataSourceSwitchWorkManager.data);
        this.dataSourceVacation.data = this.managerService.filterDataSource(this.searchValue, this.nameArray, this.dataSourceVacation.data);
        this.dataSourceWork.data = this.managerService.filterDataSource(this.searchValue, this.nameArray, this.dataSourceWork.data);
        this.dataSourceCancelVacationRequests.data = this.managerService.filterDataSource(this.searchValue, this.nameArray, this.dataSourceCancelVacationRequests.data);
        this.dataSourceCancelWorkRequests.data = this.managerService.filterDataSource(this.searchValue, this.nameArray, this.dataSourceCancelWorkRequests.data);
        this.calculateDisplayValue(this.filterEntity.year, this.filterEntity.teamName);
        this.calculateDisplayWorkValue(this.filterEntity.year, this.filterEntity.teamName);
    }

    /**
     * Refreshes Personal and WorkAbroad Table Data
     */
    private refreshPersonalAndWorkAbroadTable(): void {
        this.refreshLoading = true;
        this.initializeValue();
        for (const i of this.listOfTeamName) {
            this.getTableData(i);
        }
        setTimeout(() => {
            this.refreshLoading = false;
            this.isDisabled = false;
        }, 3000);
    }

    /**
     * Refreshes Teams table after changes
     */
    private refreshTeam(): void {
        this.refreshLoading = true;
        this.managerService.fetchTeamIdByGmin(this.gminValue).subscribe({
            next: (data) => {
                this.teamData = data;
                this.getTeamDetails(data);
                this.dataSourceTeam.data = data;
                this.getListOfTeamId();
            }, error: () => {
                this.refreshLoading = false;
                this.fabMessageService.displayErrorMessage('Error fetching data')
            }, complete: () => {
                this.refreshLoading = false;
            }
        });
    }

    /**
     * Initializes values to table value before assigning it.
     */
    private initializeValue() {
        this.vacationData = [];
        this.workAbroadData = [];
        this.vacationSwitch = [];
        this.workAbroadSwitch = [];
        this.cancelVacationData = [];
        this.cancelWorkData = [];
    }

    formatDate(dateString: string | number | Date) {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }

    /**
     * Approves all visible work abroad requests
     * Gets the value of table size from the paginator
     * and will only approve requests within the visible table
     */
    public approveAllVisibleVacations() {
        this.isApproveAllPressed = true;
        let val = 0;
        let tableValue = this.dataSourceVacation.paginator?.pageSize || '';
        let tableLength = this.dataSourceVacation.paginator?.length || '';
        let valueToCheckIfTableContentsAreLessThanTableLength;
        if (tableValue >= tableLength) {
            valueToCheckIfTableContentsAreLessThanTableLength = Number(tableLength);
        } else {
            valueToCheckIfTableContentsAreLessThanTableLength = Number(tableValue);
        }
        for (let i of this.dataSourceVacation.data) {
            val++;
            if (val <= valueToCheckIfTableContentsAreLessThanTableLength && i.requestStatus === 'PENDING') {
                this.approveVacation(i);
            } else {
                break;
            }
        }
        this.refreshPersonalAndWorkAbroadTable();
        this.isApproveAllPressed = false;
    }

    /**
     * Approves all visible work abroad requests
     * Gets the value of table size from the paginator
     * and will only approve requests within the visible table
     */
    public approveAllVisibleWorkAbroad() {
        this.refreshLoading = true;
        let val = 0;
        let tableValue = this.dataSourceWork.paginator?.pageSize || '';
        let tableLength = this.dataSourceWork.paginator?.length || '';
        let valueToCheckIfTableContentsAreLessThanTableLength;
        if (tableValue >= tableLength) {
            valueToCheckIfTableContentsAreLessThanTableLength = Number(tableLength);
        } else {
            valueToCheckIfTableContentsAreLessThanTableLength = Number(tableValue);
        }
        for (let i of this.dataSourceWork.data) {
            val++;
            if (val <= valueToCheckIfTableContentsAreLessThanTableLength && i.requestStatus === 'PENDING') {
                this.approveWork(i);
            } else {
                break;
            }
        }
        this.refreshPersonalAndWorkAbroadTable();
        this.isApproveAllPressed = false;
    }


    public openApproveOrDeclineWorkAbroadRequest(data: any) {
        this.isDisabled = true;
        this.stringIOFormat = false;
        this.isClosed = false;
        this.dialog.open(RequestCancelDecisionPopUpComponent,
            {data: {value: data, tag: 'workabroad'}}).afterClosed().subscribe(() => {
            this.stringIOFormat = true;
            this.isClosed = true;
            this.refreshPersonalAndWorkAbroadTable();
            this.sortWorkAbroadStartDate();
        });
    }

    public openApproveOrDeclineVacationRequest(vacationValue: Vacation) {
        this.isDisabled = true;
        this.refreshLoading = true;
        this.isClosed = false;
        vacationValue.updatedBy = this.gminValue;
        this.dialog.open(RequestCancelDecisionPopUpComponent,
            {data: {value: vacationValue, tag: 'personal'}}).afterClosed().subscribe(() => {
            this.stringIOFormat = true;
            this.isClosed = true;
            this.refreshPersonalAndWorkAbroadTable();
        });
    }

    clearSearchBox() {
        this.searchTxt = undefined;
    }

}
